<template>
  <layouts-header v-if="!authStore.user"></layouts-header>
  <user-header v-if="authStore.user"></user-header>

  <breadcrumb :text="text" :text1="text1" :title="title"/>
  <!-- Page Content -->
  <div class="content court-bg">
    <div class="container">
      <!-- Statistics Card -->
      <div class="row">
        <div class="col-xl-12 col-lg-12">
          <div class="card dashboard-card statistic-simply">
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 d-flex">
                <div class="statistics-grid flex-fill">
                  <div class="statistics-content">
                    <h3>{{ totalTournament }}</h3>
                    <p>Giải đấu</p>
                  </div>
                  <div class="statistics-icon">
                    <img
                        alt="Icon"
                        src="@/assets/img/icons/statistics-01.svg"
                    />
                  </div>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 d-flex">
                <div class="statistics-grid flex-fill">
                  <div class="statistics-content">
                    <h3>{{ totalMatch }}</h3>
                    <p>Trận đấu</p>
                  </div>
                  <div class="statistics-icon">
                    <img
                        alt="Icon"
                        src="@/assets/img/icons/statistics-03.svg"
                    />
                  </div>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 d-flex">
                <div class="statistics-grid flex-fill">
                  <div class="statistics-content">
                    <h3>{{ totalPlayer }}</h3>
                    <p>Vận động viên</p>
                  </div>
                  <div class="statistics-icon">
                    <img
                        alt="Icon"
                        src="@/assets/img/icons/statistics-02.svg"
                    />
                  </div>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 d-flex">
                <div class="statistics-grid flex-fill">
                  <div class="statistics-content">
                    <h3>{{ totalTeam }}</h3>
                    <p>Đội tuyển</p>
                  </div>
                  <div class="statistics-icon">
                    <img alt="Icon" src="@/assets/img/icons/member.svg"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Statistics Card -->
      <!-- Dashboard Table -->
      <div class="row">
        <div class="content court-bg">
          <div class="container">
            <div class="row">
              <div class="col-sm-12">
                <div class="court-tab-content">
                  <div class="card card-tableset">
                    <div class="card-body">
                      <div class="coache-head-blk">
                        <div class="row align-items-center">
                          <div class="col-md-5">
                            <div class="court-table-head">
                              <h4>Xếp hạng vận động viên</h4>
                            </div>
                          </div>
                          <div class="col-md-7">
                            <div class="table-search-top">
                              <div id="tablefilter">
                                <div class="dataTables_filter">
                                  <label>
                                    <input
                                        aria-controls="DataTables_Table_0"
                                        class="form-control form-control-sm"
                                        placeholder="Tìm kiếm"
                                        type="search"
                                    />
                                  </label>
                                </div>
                              </div>
                              <div class="request-coach-list">
                                <div class="card-header-btns">
                                  <nav>
                                    <div class="nav nav-tabs" role="tablist">
                                      <button
                                          id="nav-Recent-tab"
                                          aria-controls="nav-Recent"
                                          aria-selected="true"
                                          class="nav-link active"
                                          data-bs-target="#nav-Recent"
                                          data-bs-toggle="tab"
                                          role="tab"
                                          type="button"
                                      >
                                        Giải đấu
                                      </button>
                                    </div>
                                  </nav>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="tab-content">
                        <rank-table
                            :data="data"
                            :page="page"
                            :pageSize="pageSize"
                        ></rank-table>
                      </div>
                    </div>
                  </div>
                  <div class="tab-footer">
                    <div class="row">
                      <div class="col-md-6">
                        <div id="tablelength">
                          <div
                              id="DataTables_Table_0_length"
                              class="dataTables_length"
                          >
                            <label
                            >Hiển thị
                              <select
                                  class="custom-select custom-select-sm form-control form-control-sm"
                                  @change="updatePageSize"
                              >
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                              </select>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div id="tablepage">
                          <div
                              class="dataTables_paginate paging_simple_numbers"
                          >
                            <ul class="pagination">
                              <!-- Previous Page Button -->
                              <li
                                  :class="{ disabled: page === 1 }"
                                  class="paginate_button page-item"
                              >
                                <a
                                    class="page-link"
                                    href="javascript:void(0);"
                                    @click="prevPage"
                                >
                                  <i class="feather-chevrons-left"></i>
                                </a>
                              </li>

                              <li
                                  v-if="page > 3"
                                  class="paginate_button page-item"
                              >
                                <a
                                    class="page-link"
                                    href="javascript:void(0);"
                                    @click="changePage(1)"
                                >1</a
                                >
                              </li>

                              <li
                                  v-if="page > 4"
                                  class="paginate_button page-item disabled"
                              >
                                <span class="page-link">...</span>
                              </li>

                              <li
                                  v-for="p in visiblePages"
                                  :key="p"
                                  :class="{ active: p === page }"
                                  class="paginate_button page-item"
                              >
                                <a
                                    class="page-link"
                                    href="javascript:void(0);"
                                    @click="changePage(p)"
                                >{{ p }}</a
                                >
                              </li>

                              <li
                                  v-if="page < totalPages - 3"
                                  class="paginate_button page-item disabled"
                              >
                                <span class="page-link">...</span>
                              </li>

                              <li
                                  v-if="page < totalPages - 2"
                                  class="paginate_button page-item"
                              >
                                <a
                                    class="page-link"
                                    href="javascript:void(0);"
                                    @click="changePage(totalPages)"
                                >{{ totalPages }}</a
                                >
                              </li>

                              <li
                                  :class="{ disabled: page === totalPages }"
                                  class="paginate_button page-item"
                              >
                                <a
                                    class="page-link"
                                    href="javascript:void(0);"
                                    @click="nextPage"
                                >
                                  <i class="feather-chevrons-right"></i>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- /Dashboard Table -->
    </div>
  </div>
  <!-- /Page Content -->

  <layout-footer></layout-footer>

  <user-dashboard-modal></user-dashboard-modal>
</template>

<script>
import {GET_POINT_DETAILS_PAGINATE} from "@/graphql/operations/point-detail.ts";
import {radialChart} from "./data";
import {useQuery} from "@vue/apollo-composable";
import {computed, ref, watch} from "vue";
import axios from "axios";
import {useAuthStore} from "@/stores/auth";

export default {
  data() {
    const authStore = useAuthStore();
    const data = ref([]);
    const totalPlayer = ref(0);
    const totalTournament = ref(0);
    const totalMatch = ref(0);
    const totalTeam = ref(0);
    const page = ref(1);
    const pageSize = ref(10);
    const total = ref(1);

    const totalPages = computed(() => {
      return Math.ceil(total.value / pageSize.value);
    });

    const changePage = (newPage) => {
      if (newPage >= 1 && newPage <= totalPages.value) {
        page.value = newPage;
      }
    };

    const prevPage = () => {
      if (page.value > 1) {
        page.value--;
      }
    };

    const nextPage = () => {
      if (page.value < totalPages.value) {
        page.value++;
      }
    };

    const {result} = useQuery(
        GET_POINT_DETAILS_PAGINATE,
        () => ({
          page: page.value,
          pageSize: pageSize.value,
          filters: {},
        }),
        {fetchPolicy: "network-only"}
    );

    watch(
        result,
        () => {
          data.value = result.value?.pointDetails_connection?.nodes;
          total.value = result.value?.pointDetails_connection?.pageInfo?.total;
        },
        {deep: true}
    );

    const updatePageSize = (event) => {
      pageSize.value = Number(event.target.value);
      page.value = 1;
    };

    const fetchCounts = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        const token = user?.jwt;
        const config = {
          headers: {
            Authorization: `Bearer ${token}`
          }
        };

        const response = await axios.get(`${process.env.VUE_APP_SERVER_URL}/api/player/count`, config);
        const data = response.data;

        totalPlayer.value = data.totalPlayer;
        totalTournament.value = data.totalTournament;
        totalMatch.value = data.totalMatch;
        totalTeam.value = data.totalTeam;
      } catch (error) {
        console.error("Error fetching count data:", error);
      }
    };
    fetchCounts();

    return {
      authStore,
      data,
      page,
      pageSize,
      result,
      updatePageSize,
      totalPages,
      changePage,
      prevPage,
      nextPage,
      title: "Xếp hạng",
      text: "Trang chủ",
      text1: "Xếp hạng",
      Week: ["This Week", "One Day"],
      radialChart: radialChart,
      totalPlayer,
      totalTournament,
      totalMatch,
      totalTeam,
    };
  },
  computed: {
    visiblePages() {
      let pages = [];
      let start = Math.max(1, this.page - 2);
      let end = Math.min(this.totalPages, this.page + 2);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },
  },
};
</script>
